import { render, staticRenderFns } from "./indexRiesgoReproductivoShow.vue?vue&type=template&id=4ad49176&"
import script from "./indexRiesgoReproductivoShow.vue?vue&type=script&lang=js&"
export * from "./indexRiesgoReproductivoShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports